<template>
	<div :id="id" ref="swipertest" v-show="!hidden">
		<a
			v-for="(image, key) in images"
			:key="key"
			:href="image.url"
			:data-pswp-width="image.width"
			:data-pswp-height="image.height"
			target="_blank"
			rel="noreferrer"
		>
			<img :src="image.url" />
		</a>
	</div>
</template>

<script>
import { ref, onMounted, onUnmounted, getCurrentInstance } from 'vue';

import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/style.css';

export default {
	name: 'ImageSwiper',

	props: {
		id: {
			type: String,
			default: 'entry-media-swiper'
		},
		images: {
			type: Array,
			required: true
		},
		hidden: {
			type: Boolean,
			default: false
		}
	},

	setup(props) {
		const swipertest = ref(null);
		const lightbox = ref(null);

		const { proxy } = getCurrentInstance();

		const log = (message, data = null) => {
			const payload = data ? `${message} ${JSON.stringify(data)}` : message;
			proxy.$logger?.(payload);
		};

		const setNativeArticleSwipeLocked = (locked) => {
			log('app/component/image-swiper/setNativeArticleSwipeLocked fired', {
				locked,
				hasHelper: Boolean(proxy.$helper),
				hasSendAppMessage: Boolean(proxy.$helper?.sendAppMessage)
			});

			proxy.$helper?.sendAppMessage({
				action: 'articleGallerySwipeLock',
				locked
			});

			log('app/component/image-swiper/setNativeArticleSwipeLocked sent', {
				locked
			});
		};

		const initLightbox = () => {
			log('app/component/image-swiper/init-lightbox', {
				id: props.id,
				imageCount: props.images.length
			});

			lightbox.value = new PhotoSwipeLightbox({
				gallery: '#' + props.id,
				children: 'a',
				pswpModule: () => import('photoswipe')
			});

			lightbox.value.on('beforeOpen', () => {
				log('app/component/image-swiper/photoswipe beforeOpen');
				setNativeArticleSwipeLocked(true);
			});

			lightbox.value.on('close', () => {
				log('app/component/image-swiper/photoswipe close');
				setNativeArticleSwipeLocked(false);
			});

			lightbox.value.on('destroy', () => {
				log('app/component/image-swiper/photoswipe destroy');
				setNativeArticleSwipeLocked(false);
			});

			lightbox.value.init();
			log('app/component/image-swiper/photoswipe initialized');

			lightbox.value.loadAndOpen(1);
			log('app/component/image-swiper/loadAndOpen called', {
				index: 1
			});
		};

		onMounted(() => {
			log('app/component/image-swiper/mounted', {
				hidden: props.hidden,
				imageCount: props.images.length
			});


			if (!props.hidden) {
				initLightbox();
			} else {
				log('app/component/image-swiper/init skipped because hidden is true');
			}
		});

		onUnmounted(() => {
			log('app/component/image-swiper/unmounted');

			setNativeArticleSwipeLocked(false);

			if (lightbox.value) {
				lightbox.value.destroy();
				lightbox.value = null;
			}
		});

		return {
			swipertest,
			initLightbox
		};
	}
};
</script>

<style>
</style>